import React, {useState} from 'react'
import {useHistory} from 'react-router-dom'
import PropTypes from 'prop-types'
import Star from 'hec/assets/icons/star'
import Quiz from 'hec/assets/icons/quiz'
import ClockLight from 'hec/assets/icons/clock-light'
import {cn} from '@/lib/utils'
import useLearningCenter from '~/app/hooks/use-learning-center'
import {useLearningCenterMutation, useFetchModulePageUrl} from 'hec/hooks/learning-center'

const ModuleCard = ({moduleData, levelID, levelStarted, goalID}) => {
    const [requestInProgress, setRequestInProgress] = useState(false)
    const {
        moduleID,
        image,
        title,
        moduleNumber,
        allLessonsQty,
        completeLessonsQty,
        estimatedCompletionTime,
        complete,
        started
    } = moduleData
    const {startModule, startLevel, setActiveLesson} = useLearningCenterMutation()
    const {learningCenterData: sfccLearningCenterData} = useLearningCenter()
    const {modulePageUrl} = useFetchModulePageUrl({moduleId: moduleID})
    const history = useHistory()

    const handleClick = async () => {
        if (requestInProgress) return

        if (!levelStarted || !started) {
            setRequestInProgress(true)
            const newData = structuredClone(sfccLearningCenterData)
            if (!levelStarted) {
                startLevel(levelID, goalID, newData)
            }
            const response = await startModule(moduleID, levelID, newData)
            if (!response.success) {
                throw new Error(response.errorMsg)
            }
            setActiveLesson(modulePageUrl)
            setRequestInProgress(false)
        }

        history.push(modulePageUrl)
    }

    return (
        <button
            className="p-3 bg-white rounded-md w-full h-full cursor-pointer flex flex-col"
            onClick={handleClick}
        >
            <img className="w-full mb-4 aspect-video rounded-md" src={image} alt={title} />
            <p className="body-header-lg">Module {moduleNumber}:</p>
            <p className="body-sm mb-2 text-left">{title}</p>
            <div className="flex items-center mb-8">
                {Array.from({length: allLessonsQty - 1}).map((lesson, lessonIndex) => {
                    const lessonComplete = lessonIndex < completeLessonsQty

                    return (
                        <Star
                            key={lessonIndex}
                            className={cn(
                                '[&>path]:fill-primary w-[1.3125rem] h-[1.3125rem] mr-2',
                                !lessonComplete && 'opacity-40'
                            )}
                        />
                    )
                })}
                {
                    <Quiz
                        className={cn(
                            '[&>path]:fill-primary w-[1.3125rem] h-[1.3125rem]',
                            !complete && 'opacity-40'
                        )}
                    />
                }
            </div>
            <div className="flex mt-auto w-full items-center justify-between">
                <div className="flex items-center">
                    <ClockLight className="w-5 h-5 mr-2 -mt-px" />
                    <span className="body-sm mt-1">{estimatedCompletionTime}</span>
                </div>
                <div className="body-sm mt-1">
                    {completeLessonsQty}/{allLessonsQty} Complete
                </div>
            </div>
        </button>
    )
}

ModuleCard.propTypes = {
    moduleData: PropTypes.shape({
        moduleID: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
        moduleNumber: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        allLessonsQty: PropTypes.number.isRequired,
        completeLessonsQty: PropTypes.number.isRequired,
        estimatedCompletionTime: PropTypes.string.isRequired,
        complete: PropTypes.bool.isRequired,
        started: PropTypes.bool.isRequired
    }).isRequired,
    levelID: PropTypes.string.isRequired,
    levelStarted: PropTypes.bool.isRequired,
    goalID: PropTypes.string.isRequired
}

export default ModuleCard
